/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {listAppointments} from '../api'

export const useMutationListAppointments = createReactQueryMutationHook('listAppointments', listAppointments)
